import styled from 'styled-components'

const Actions = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export default Actions
